module.exports = __webpack_public_path__ + "img/items-icon.307c705a.svg";